//This is for the new bug ticket modal. It will be temporary until we roll out.

const newBugTicketUsers: string[] = [
  "carling.sugarman@tinuiti.com",
  "brenna.huggins@tinuiti.com",
  "justin.manus@tinuiti.com",
  "lauren.wolfen@tinuiti.com",
  // Add users here!
];

export const shouldEnableBugTicket = (userEmail: string): boolean => {
  return newBugTicketUsers.includes(userEmail);
};
